export const FETCH_TESTIMONIALS = 'FETCH_TESTIMONIALS';
export const FETCH_TESTIMONIALS_SUCCESS = 'FETCH_TESTIMONIALS_SUCCESS';
export const FETCH_TESTIMONIALS_FAIL = 'FETCH_TESTIMONIALS_FAIL';

export const TESTIMONIALS_PAGE_COUNT = 3;
export const TESTIMONIALS_MIN_RATING = 4;
